import {combineReducers} from 'redux';
import keyDeals from './keyDeals';
import apiData from './apiData';
import currentRegion from './currentRegion';
import currentRegionLabel from './currentRegionLabel';
import currentLocation from './currentLocation';
import currentLocationLabel from './currentLocationLabel';
import currentLocationIndex from './currentLocationIndex';
import userValidated from './userValidated';
const rootReducer = combineReducers({ keyDeals , apiData, currentRegion , currentRegionLabel , currentLocation , currentLocationLabel , currentLocationIndex , userValidated});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/js/reducers/index.js